import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { CoordinatePatient } from '~/types/coordinate';

interface Props {
  open: boolean;
  onClose: () => void;
  patient: CoordinatePatient;
  providerName: string;
}

const EHRNoteDialog: React.FC<Props> = ({ open, onClose, patient, providerName }) => {
  const [copied, setCopied] = useState(false);

  const note = `Post-acute care coordination completed. ${patient.name} evaluated for ${patient.disposition.replace(/_/g, ' ')} placement. ${providerName} selected based on clinical fit and expected start within 24–48 hours. Referral packet prepared and sent on ${new Date().toLocaleDateString()}.\n\nClinical needs addressed: ${patient.clinicalNeeds.map(n => n.replace(/_/g, ' ')).join(', ')}.\n\nPrimary diagnoses: ${patient.diagnoses.join('; ')}.`;

  const handleCopy = () => {
    navigator.clipboard.writeText(note);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Write Discharge Planning Note to EHR</DialogTitle>
      <DialogContent>
        <Alert severity="info" sx={{ mb: 2 }}>
          This note would be written to the EHR. No other EHR fields will be modified.
        </Alert>
        <Box
          sx={{
            p: 2,
            backgroundColor: 'grey.50',
            borderRadius: 1,
            fontFamily: 'Georgia, serif',
            fontSize: '0.9rem',
            lineHeight: 1.8,
            whiteSpace: 'pre-wrap',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          {note}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          startIcon={<ContentCopyIcon />}
          onClick={handleCopy}
          color={copied ? 'success' : 'inherit'}
        >
          {copied ? 'Copied!' : 'Copy to Clipboard'}
        </Button>
        <Button onClick={onClose} variant="contained">Dismiss</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EHRNoteDialog;
